module.exports = __webpack_public_path__ + "images/kpnb488ea08419e81908fd9280cff21e516.png";